export default __webpack_public_path__ + "static/media/result.d3b060ad.svg";